import * as React from 'react';
import { Upload, Switch, Space } from 'antd';
import { UploadProps } from 'antd/lib/upload';
import { useTranslation } from 'react-i18next';
import { I18N_NS } from 'Config/i18n';
import { API } from 'General/API';
import { API_URL } from 'General/APIEndpoints';
import { ModalComponentProps } from 'Components/General/Modal/ModalContext';
import { Button } from 'Components/General/Button';
import { notificationSuccess } from 'utils/libHelpers/AntdNotification';

interface ImportMetadataProps extends ModalComponentProps {
  projectId: number;
  afterSuccess: () => void;
}

export const ImportMetadata = ({ projectId, hideModal, setConfirmOnCancel, afterSuccess }: ImportMetadataProps) => {
  const [file, setFile] = React.useState(null);
  const [fileList, setFileList] = React.useState([]);
  const [override, setOverride] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const { t } = useTranslation(I18N_NS.ADMIN);

  const toggleOverride = () => setOverride(!override);

  const uploadFile = async () => {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append('file', file);
      const params: { force?: boolean } = { force: override };
      await API.newData(API_URL.METADATA.importMetadataFromExcel(projectId), formData, params);
      setConfirmOnCancel(false);
      hideModal();
      notificationSuccess(t('Success'), file.name + t(' was successfully imported'));
      afterSuccess();
    } catch (error) {
      throw error;
    } finally {
      setLoading(false);
    }
  };

  const uploadProps: UploadProps = {
    name: 'file',
    action: '',
    accept: '.xlsx',
    multiple: false,
    beforeUpload: (file, fileList) => {
      setFileList(fileList);
      setFile(file);
      setConfirmOnCancel(true);
      return false;
    },
    fileList,
    onRemove: () => { setFile(null); setFileList([]); setConfirmOnCancel(false); }
  };

  return (
    <div>
      <div className="mb-md">
        <Upload {...uploadProps}>
          <Button faIcon={['far', 'download']}>{t('Import file (.xlsx)')}</Button>
        </Upload>
      </div>
      <div onClick={toggleOverride} className="pointer">
        <Space className="mb-md" size="small">
          <Switch checked={override} /><div>{t('Override existing value ranges')}</div>
        </Space>
      </div>
      <div className="text-right">
        <Button loading={loading} onClick={uploadFile} className="mr-5" type="primary">{t('Import')}</Button>
      </div>
    </div>
  );
};